import { Injectable } from '@angular/core';
import { UserState } from '../../../shared';
import { BehaviorSubject, filter, first, interval, map, startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "../../../shared";
import * as i2 from "../../../basic-features";
import * as i3 from "@ngxs/store";
export class NotificationsV2Service {
  apiService;
  errorHandler;
  _destroyRef;
  store;
  zone;
  pollingInterval = 12000; // 12 sec
  _notifications$ = new BehaviorSubject([]);
  get notifications$() {
    return this._notifications$.asObservable();
  }
  get unreadNotifications$() {
    return this._notifications$.asObservable().pipe(map(notifications => notifications.filter(n => n.status === 'UNREAD')));
  }
  constructor(apiService, errorHandler, _destroyRef, store, zone) {
    this.apiService = apiService;
    this.errorHandler = errorHandler;
    this._destroyRef = _destroyRef;
    this.store = store;
    this.zone = zone;
  }
  fetchNotifications() {
    this.apiService.getList().pipe(first(), map(notifications => notifications.filter(n => n.status !== 'DELETED'))).subscribe(notifications => this._notifications$.next(notifications));
  }
  markAsRead(notification) {
    if (notification.status === 'UNREAD') {
      this.apiService.markAsRead(notification.id).subscribe({
        next: () => {
          this._notifications$.next(this._notifications$.getValue().map(n => n.id === notification.id ? {
            ...n,
            status: 'READ'
          } : n));
        },
        error: error => this.errorHandler.handleError(error)
      });
    }
  }
  markAllAsRead() {
    const unreadIds = this._notifications$.getValue().filter(n => n.status === 'UNREAD').map(n => n.id);
    this.apiService.markAllAsRead(unreadIds).pipe(first()).subscribe({
      next: () => {
        // reload
        this.fetchNotifications();
      },
      error: error => this.errorHandler.handleError(error)
    });
  }
  usePollingNotification() {
    if (this.pollingInterval < 1000) {
      throw new Error('Notification Polling interval too low. Deactivated polling.');
    } else {
      // Interval is run outside of Angular zone to prevent change detection. This makes Angular
      // Testability API undestand that the page has become stable as is not currently waiting.
      // We then can use the Angular Testability API to check if the page is stable and the
      // test runner should proceed.
      this.zone.runOutsideAngular(() => this.pollNotificationsWhenLoggedIn());
    }
  }
  pollNotificationsWhenLoggedIn() {
    return interval(this.pollingInterval).pipe(startWith(0), takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      // The fetch request itself must be run inside the angular zone so the API undestands
      // that Angular is currently unstable and the test runner should wait.
      this.zone.run(() => this.store.select(UserState.authState).pipe(filter(authState => authState === "logged in" /* AuthState.LoggedIn */), first()).subscribe(() => this.fetchNotifications()));
    });
  }
  static ɵfac = function NotificationsV2Service_Factory(t) {
    return new (t || NotificationsV2Service)(i0.ɵɵinject(i1.UserNotificationsApiService), i0.ɵɵinject(i2.ErrorHandlerV2Service), i0.ɵɵinject(i0.DestroyRef), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i0.NgZone));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsV2Service,
    factory: NotificationsV2Service.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsV2Service, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.UserNotificationsApiService
  }, {
    type: i2.ErrorHandlerV2Service
  }, {
    type: i0.DestroyRef
  }, {
    type: i3.Store
  }, {
    type: i0.NgZone
  }], null);
})();
